import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_italic,
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const timeline = css`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`

export const activity = css`
  display: grid;
  grid-template-columns: ${spacing(6)} minmax(0, 1fr);
  column-gap: ${spacing(2)};
  position: relative;
  padding-bottom: ${spacing(4)};

  &:not(:last-child)::before {
    background: ${base_colorContentBorder};
    content: '';
    position: absolute;
    top: ${spacing(6)};
    bottom: 0;
    left: calc(${spacing(6)} / 2);
    width: 1px;
  }

  &:last-child {
    padding-bottom: 0;
  }
`

export const avatar = css`
  z-index: 1;
`

export const content = css`
  min-width: 0;
`

export const actorRow = css`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: ${spacing(1)};
`

export const actorName = css`
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_regular};
  ${font_sm};
`

export const metadataSeparator = css`
  color: ${text_colorTextSecondary};
  ${font_sm};
`

export const occurredAt = css`
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_regular};
  ${font_sm};
`

export const event = css`
  align-items: baseline;
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing(1)};
  margin-top: ${spacing(1)};
  min-width: 0;
`

export const eventTitle = css`
  color: ${text_colorTextPrimary};
  font-family: ${font_family_weight_regular};
  ${font_md};
  min-width: 0;
`

export const amount = css`
  color: ${text_colorTextPrimary};
  font-family: ${font_family_weight_medium};
  ${font_md};
  white-space: nowrap;
`

export const details = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  margin-top: ${spacing(1)};
  min-width: 0;
`

export const quote = css`
  color: ${text_colorTextPrimary};
  font-family: ${font_family_weight_italic};
  ${font_sm};
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`

export const visuallyHidden = css`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const change = css`
  color: ${text_colorTextPrimary};
  margin: 0;
  overflow-wrap: anywhere;
  ${font_sm};
`

export const detailLabel = css`
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_medium};
  margin-right: ${spacing(1)};
`

export const status = css`
  color: ${text_colorTextPrimary};
  ${font_sm};

  p {
    margin: 0;
    overflow-wrap: anywhere;
  }
`

export const reason = css`
  color: ${text_colorTextSecondary};
`
